import React from "react";
import { CssBaseline } from "@material-ui/core";
import { ReactComponent as DataVisOverall } from "../../assets/data_vis/data_vis_overall.svg";
import { ReactComponent as DataVisWeek } from "../../assets/data_vis/data_vis_week.svg";
import { ReactComponent as DataVisDay } from "../../assets/data_vis/data_vis_day.svg";
import { ReactComponent as PieChart1 } from "../../assets/data_vis/pie_chart1.svg";
import { ReactComponent as PieChart2 } from "../../assets/data_vis/pie_chart2.svg";
import { ReactComponent as DataVisGroup1 } from "../../assets/data_vis/data_vis_group1.svg";
import { ReactComponent as DataVisGroup2 } from "../../assets/data_vis/data_vis_group2.svg";
import useStyles from "./styles";
import { useQuery, gql } from "@apollo/client";

const GET_USER = gql`
  query {
    User(username: "iko") {
      username
    }
  }
`;

const Dashboard = () => {
  const classes = useStyles();
  const { loading, error, data } = useQuery(GET_USER);

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error</p>;
  if (!data) return <p>Not found</p>;

  return (
    <div id="dashboard" className={classes.root}>
      <CssBaseline />
      <div className={classes.dataGroup1}>
        <DataVisOverall className={classes.dataVis} />
        <DataVisWeek />
        <DataVisDay />
      </div>
      <div className={classes.dataGroup2}>
        <PieChart1 className={classes.dataVis} />
        <PieChart2 className={classes.dataVis} />
        <DataVisGroup1 />
        <DataVisGroup2 />
      </div>
    </div>
  );
};

export default Dashboard;
